export function hideIntercomWidget(hide) {
  if (hide) {
    window.Intercom('update', { hide_default_launcher: true })
  } else {
    window.Intercom('update', { hide_default_launcher: false })
  }
}
